import * as React from 'react'
import {Form, Input} from 'antd'
import { TTFormItem } from '../../shared/TTFormItem'
import {TTSelect} from "../../shared/TTSelect";
import {renderSelectKeyValue} from "../../shared/SelectOptionRenderUtils";

interface FormUtenteProps {
    nominativo: string
    onNominativoChange: (value: string) => void

    username: string
    onUsernameChange: (value: string) => void

    email: string
    onEmailChange: (value: string) => void
}

export const FormUtente: React.FC<FormUtenteProps> = (props) => {
    return <>
        <TTFormItem label="Nominativo" required={true}>
            <Input value={props.nominativo} onChange={e => props.onNominativoChange(e.target.value)} />
        </TTFormItem>
        <TTFormItem label="Username" required={true}>
            <Input value={props.username} onChange={e => props.onUsernameChange(e.target.value)} />
        </TTFormItem>
        <TTFormItem label="Email" required={true}>
            <Input type="email" value={props.email} onChange={e => props.onEmailChange(e.target.value)} />
        </TTFormItem>
        
    </>
}